import { render, staticRenderFns } from "./tendersModal.vue?vue&type=template&id=4da02a54&scoped=true&"
import script from "./tendersModal.vue?vue&type=script&lang=js&"
export * from "./tendersModal.vue?vue&type=script&lang=js&"
import style0 from "./tendersModal.vue?vue&type=style&index=0&id=4da02a54&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4da02a54",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/corp-dev.1clicom.ru/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4da02a54')) {
      api.createRecord('4da02a54', component.options)
    } else {
      api.reload('4da02a54', component.options)
    }
    module.hot.accept("./tendersModal.vue?vue&type=template&id=4da02a54&scoped=true&", function () {
      api.rerender('4da02a54', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/card/tenders/tendersModal.vue"
export default component.exports